import { useRef, useState } from "react";
import { Plus } from "lucide-react";
import { TaskCard } from "./TaskCard";
import { STATUSER, sorterSaker } from "./sakerUtils";

const Kolonne = ({ status, saker, members, today, onOpen, onDrop, onQuickAdd, onStatus }) => {
  const [over, setOver] = useState(false);
  return (
    <div
      className={`sak-kolonne flex flex-col min-h-[240px] transition-colors ${over ? "dra-over" : ""}`}
      style={{ borderTopColor: status.dot }}
      onDragOver={(e) => { e.preventDefault(); setOver(true); }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => {
        e.preventDefault();
        setOver(false);
        const id = e.dataTransfer.getData("text/sak");
        if (id) onDrop(status.k, id);
      }}
      data-testid={`saker-kolonne-${status.k}`}
    >
      <div className="flex items-center gap-2 px-1 pt-2.5 pb-1.5">
        <span className="w-2 h-2 rounded-full shrink-0" style={{ background: status.dot }} />
        <span className="text-[10.5px] font-semibold uppercase tracking-[0.14em] text-neutral-500">{status.label}</span>
        <span className="bud-mono text-[10.5px] tabular-nums text-neutral-400">{saker.length}</span>
        <button
          type="button"
          onClick={() => onQuickAdd(status.k)}
          className="ml-auto text-neutral-400 hover:text-neutral-800 hover:bg-neutral-200/60 rounded p-1 transition-colors"
          title={`Ny sak i ${status.label}`}
          data-testid={`saker-kolonne-add-${status.k}`}
        >
          <Plus size={14} strokeWidth={2.2} />
        </button>
      </div>
      <div className="flex flex-col gap-2 pt-1.5 overflow-y-auto">
        {saker.map((sak, i) => (
          <TaskCard key={sak.id} sak={sak} index={i} members={members} today={today} onOpen={onOpen} onStatus={onStatus} />
        ))}
        {saker.length === 0 && (
          <p className={`text-[11px] text-center py-7 select-none transition-colors ${over ? "text-amber-600 font-medium" : "text-neutral-400"}`}>
            {over ? "Slipp saken her" : "Ingen saker"}
          </p>
        )}
      </div>
    </div>
  );
};

export const TaskBoard = ({ saker, members, today, onOpen, onDrop, onQuickAdd, onStatus }) => {
  const tavleRef = useRef(null);
  const [aktiv, setAktiv] = useState(0);

  const vedScroll = () => {
    const el = tavleRef.current;
    if (!el) return;
    const maks = el.scrollWidth - el.clientWidth;
    if (maks <= 0) return;
    setAktiv(Math.round((el.scrollLeft / maks) * (STATUSER.length - 1)));
  };

  const tilKolonne = (i) => {
    const barn = tavleRef.current?.children?.[i];
    if (barn) barn.scrollIntoView({ behavior: "smooth", inline: "start", block: "nearest" });
  };

  return (
    <div>
      <div ref={tavleRef} onScroll={vedScroll} className="sak-tavle" data-testid="saker-tavle">
        {STATUSER.map((s) => (
          <Kolonne
            key={s.k}
            status={s}
            saker={saker.filter((t) => (t.status || "inbox") === s.k).sort(sorterSaker)}
            members={members}
            today={today}
            onOpen={onOpen}
            onDrop={onDrop}
            onQuickAdd={onQuickAdd}
            onStatus={onStatus}
          />
        ))}
      </div>
      <div className="sak-dots" data-testid="saker-tavle-dots">
        {STATUSER.map((s, i) => (
          <button key={s.k} type="button" onClick={() => tilKolonne(i)} className="p-1.5" aria-label={s.label} data-testid={`saker-dot-${s.k}`}>
            <span
              className="block w-1.5 h-1.5 rounded-full transition-all"
              style={{ background: i === aktiv ? s.dot : "#D6D2C6", transform: i === aktiv ? "scale(1.5)" : "none" }}
            />
          </button>
        ))}
      </div>
    </div>
  );
};
